import axios from 'axios'

import { env } from '@/app/env'
import { applyInterceptors } from './apply-interceptors'

export const apiOpsV2 = (() => {
  const client = axios.create({ baseURL: env.opsV2BaseUrl })
  applyInterceptors(client)
  return client
})()
